var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.selectPlugin != null && !_vm.isNewRegistrationMethod)?_c('iframe',{ref:"iframeSystemSettings",staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"show-plugin","frameBorder":"0"}}):_vm._e(),(_vm.isNewRegistrationMethod)?_c(_vm.currentcomponent,{key:_vm.pluginInfo.plugin_id,tag:"component"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }